// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Gallery_invalidDataError__+Io9k"};